import { render, staticRenderFns } from "./SsDate.vue?vue&type=template&id=73883455&"
import script from "./SsDate.vue?vue&type=script&lang=js&"
export * from "./SsDate.vue?vue&type=script&lang=js&"
import style0 from "./SsDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports